<img
      [src]="currentSrc"
      [alt]="alt"
      (load)="onImageLoad()"
      (error)="onImageError()"
      [class.loaded]="isLoaded"
      class="lazy-image"
    />
